import { BanknoteArrowDown, BanknoteArrowUpIcon, Book, BookCheck, BookOpen, CirclePlus, Clipboard, Clock, ContactRound, Home, LayoutDashboard, LayoutGrid, LogOut, Map, MapPin, Moon, NotebookPen, PlusCircle, Shield, ShieldCheck, Sun, X } from "lucide-react";
import Nav from "../../global-components/src/components/navbar-pc/navbar-pc";
import NavbarPCLink from "../../global-components/src/components/navbar-pc/navbar-pc-link";
import { useAuth, useTheme } from '../../global-components/src';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { CRONOS_URL, PACOCA_API_URL, PACOCA_URL, RITA_URL } from "../../global-components/src/utils/vars";
import { isMyLove } from "../../global-components/src/utils/auth";
import { AppsLinkPC } from "../../global-components/src/components/navbar-pc/apps-link-pc";
import "./style.css";
import { System } from "../../global-components/src/types";
import { NavbarPCDropdownItem } from "../../global-components/src/components/navbar-pc/navbar-pc-dropdown-item";
import { NavbarPCDropdown } from "../../global-components/src/components/navbar-pc/navbar-pc-dropdown";
import { Icon } from "../../global-components/src/components/icon";
 
export default function Lala(){
    const { isAuthenticated, user } = useAuth();
    const { isDarkMode } = useTheme();
    const location = useLocation();
    const path = location.pathname;
    const navigate = useNavigate();

    return (
        <div  style={{display: (path == "/" || path == "/cadastro" || path == "/login") && !isAuthenticated ? "none" : "block"}}>
            <Nav actionSearch="/livros/criar" showSearchForm={isAuthenticated} className="fixed-top navbar-pc" linkProfile="/conta" title="Meu Menu" img="/img/estante_icon.png">
                {path !== "/"
                    ? (
                        <>
                           <NavbarPCLink link="/" className="" aria-label="Ir para home">
                                <Icon  invertColor={isDarkMode} active={path == "/"} alt="Ir para home" size={32} name="home">
                                    <Home className={`icon-menu-dark ${path == "/" ? 'active' : ''}`}/>
                                </Icon>
                            </NavbarPCLink>

                            {isAuthenticated ? (
                                <>
                                    <AppsLinkPC system={System.readbooks} />

                                    <NavbarPCDropdown content={<BookOpen className='icon-menu-dark'/>}>
                                        <NavbarPCDropdownItem onClick={ () => navigate("/livros/criar") }>
                                            <PlusCircle style={{ height: '19px', marginRight: '3px' }}/>
                                            Adicionar livro
                                        </NavbarPCDropdownItem>
                                        <NavbarPCDropdownItem onClick={ () => navigate("/livros/publicados") }>
                                            <BookOpen style={{ height: '19px', marginRight: '3px' }}/>
                                            Livros com PDF
                                        </NavbarPCDropdownItem>
                                        <NavbarPCDropdownItem onClick={ () => navigate("/dashboard") }>
                                            <LayoutDashboard style={{ height: '19px', marginRight: '3px' }}/>
                                            Dashboard
                                        </NavbarPCDropdownItem>
                                    </NavbarPCDropdown>
                                    
                                    <NavbarPCDropdown content={<NotebookPen className='icon-menu-dark'/>}>
                                        <NavbarPCDropdownItem onClick={ () => navigate("/catalogo") }>
                                            <BookCheck style={{ height: '19px', marginRight: '3px' }}/>
                                            Livro publicados
                                        </NavbarPCDropdownItem>
                                        <NavbarPCDropdownItem onClick={ () => navigate("/livros/publicar") }>
                                            <BookCheck style={{ height: '19px', marginRight: '3px' }}/>
                                            Publicar livro
                                        </NavbarPCDropdownItem>
                                        <NavbarPCDropdownItem onClick={ () => navigate("/autor/ganhos") }>
                                            <BanknoteArrowUpIcon style={{ height: '19px', marginRight: '3px' }}/>
                                            Meus Ganhos
                                        </NavbarPCDropdownItem>
                                    </NavbarPCDropdown>
                                    
                                    {user && (user?.position > 0 || user?.stamps?.includes("brown")) ? (
                                        <NavbarPCDropdown content={<ShieldCheck className='icon-menu-dark'/>}>
                                            <NavbarPCDropdownItem onClick={ () => navigate("/admin/livros") }>
                                                <Book style={{ height: '19px', marginRight: '3px' }}/>
                                                Livros pendentes 
                                            </NavbarPCDropdownItem>
                                            <NavbarPCDropdownItem onClick={ () => navigate("/admin/saques") }>
                                                <BanknoteArrowDown style={{ height: '19px', marginRight: '3px' }}/>
                                                Saques
                                            </NavbarPCDropdownItem>
                                        </NavbarPCDropdown>
                                    ): null}
                                </>
                            ) : null}
                        </>

                ) : null
                }
            </Nav>
        </div>
    )
}